export default "__VITE_ASSET__DPUgpt6m__"